this.customElements.define(
  'results-cards',
  class extends HTMLElement {
    async connectedCallback() {
      this.slider = this.querySelector('[data-results-cards-slider]');

      if (!this.slider || this.slider.swiper) {
        return;
      }

      this.previousButton = this.querySelector('[data-results-cards-prev]');
      this.nextButton = this.querySelector('[data-results-cards-next]');
      this.pagination = this.querySelector('[data-results-cards-dots]');
      this.originalCount = Number(this.slider.getAttribute('data-original-count')) || 0;

      if (this.originalCount <= 1) {
        return;
      }

      await this.waitForSwiper();

      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        pauseOnMouseEnter: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.previousButton,
        },
        pagination: {
          el: this.pagination,
          type: 'bullets',
          clickable: true,
          bulletClass: 'results-cards__dot',
          bulletActiveClass: 'is-active',
          renderBullet: (index, className) => {
            if (this.originalCount > 0 && index >= this.originalCount) {
              return `<button class="${className}" type="button" tabindex="-1" aria-hidden="true" style="display:none"></button>`;
            }

            return `<button class="${className}" type="button" aria-label="Show transformation ${index + 1}"></button>`;
          },
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
          },
        },
        speed: 500,
        effect: 'slide',
        grabCursor: true,
        watchOverflow: false,
        on: {
          slideChange: (swiper) => {
            if (!this.originalCount || !this.pagination) {
              return;
            }

            const realIndex = swiper.realIndex % this.originalCount;
            const bullets = this.pagination.querySelectorAll('.results-cards__dot');

            bullets.forEach((bullet, index) => {
              bullet.classList.toggle('is-active', index === realIndex);
            });
          },
        },
      });
    }

    waitForSwiper() {
      return new Promise((resolve) => {
        if (window.Swiper) {
          resolve();
          return;
        }

        const checkSwiper = () => {
          if (window.Swiper) {
            resolve();
            return;
          }

          window.setTimeout(checkSwiper, 50);
        };

        checkSwiper();
      });
    }
  },
);
